import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../components/atoms/Button';
import { TRANSLATION_KEY } from '../constants';
import css from '../style.css';

const EmptyState = ({ translate, readOnly = false, onCreate }) => (
    <div className={css.emptyState}>
        <h5>{translate(`${TRANSLATION_KEY}.EMPTY_TITLE`)}</h5>
        <img className={css.emptyIcon} src="/static/dashboard/img/fraud_no_rules_icon.svg" alt="" />
        <Button type="primary" text={`${TRANSLATION_KEY}.CREATE_FIRST_RULE`} disabled={readOnly} onClick={onCreate} />
    </div>
);

EmptyState.propTypes = {
    translate: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    onCreate: PropTypes.func.isRequired,
};

export default EmptyState;
